/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import styled, { css } from 'styled-components';

import Title from '../shared/Title';
import { palette } from '../../constants/styles';
import Icon from '../shared/Icon';


const FinancialStep = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${palette.sweetGray};
  border-radius: 15px;
  width: 95%;
  padding: 5px 15px;
  margin-top: 50px;
  z-index: 300;
`;

const StyledLock = css`
  margin-right: 20px;
`;


const Blocked = ({ number, title }) => (
  <FinancialStep>
    <Title level={4}>
      <b>Paso {number}:</b> <span style={{ fontWeight: '500' }}>{title}</span>
    </Title>
    <Icon icon="lock" color={palette.sublimeGray} size={35} styles={StyledLock} />
  </FinancialStep>
);

export default Blocked;
